<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,8C13,8,8,8,8,8C8,8,8,13,8,13C8,13,13,13,13,13C13,13,13,8,13,8C13,8,13,8,13,8ZM13,3C13,3,8,3,8,3C8,3,8,7,8,7C8,7,13,7,13,7C13,7,13,3,13,3C13,3,13,3,13,3ZM15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM14,14C14,14,2,14,2,14C2,14,2,2,2,2C2,2,14,2,14,2C14,2,14,14,14,14C14,14,14,14,14,14ZM7,3C7,3,3,3,3,3C3,3,3,13,3,13C3,13,7,13,7,13C7,13,7,3,7,3C7,3,7,3,7,3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Control',
} as DefineComponent
</script>
